/**
 * BellaM'Briana Jewel — Luxury Smooth Scroll (powered by Lenis)
 * Only active on desktop pointer devices.
 */
(function () {
  if (window.matchMedia('(pointer: coarse)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var script = document.createElement('script');
  script.src = 'https://unpkg.com/lenis@1/dist/lenis.min.js';
  script.onload = function () {
    var lenis = new Lenis({
      duration: 1.8,
      easing: function (t) {
        return Math.min(1, 1.001 - Math.pow(2, -10 * t));
      },
      smoothWheel: true,
      wheelMultiplier: 0.35,
      touchMultiplier: 1,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  };
  document.head.appendChild(script);
})();
